export default __webpack_public_path__ + "static/media/LSVD-BB.aeb0c73e.mov";